import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import * as libraryActions from '~/library/actions';
import AutosuggestFilter from '~/containers/AutosuggestFilter';
import Helpers from '~/utils/Helpers';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
type LibraryViewCommitHashProps = {
  libraryState: object;
  actions: object;
  navigationState: object;
};
class LibraryViewCommitHash extends React.Component<LibraryViewCommitHashProps, {}> {
  constructor(props, context) {
    super(props, context);
    this.delayedHandleCommitHashChange = _.debounce(this.handleCommitHashChange.bind(this), 300);
  }
  componentDidMount() {
    const { libraryState, navigationState } = this.props;
    const { commitHash } = libraryState;
    const { activeParams = {} } = navigationState;
    let activeCommitHash = activeParams.commitHash ? activeParams.commitHash : commitHash;
    if (Helpers.isCommitHash(activeCommitHash)) {
      this.props.actions.updateCommitHash(activeCommitHash);
    }
  }
  getLatestCommitHashes(versions, version) {
    const versionObj = versions.find(versionObj => versionObj.version === version);
    return versionObj && versionObj.latestCommitsPreview;
  }
  handleCommitHashChange = commitHash => {
    const newCommitHash = Helpers.isCommitHash(commitHash) ? commitHash : '-';
    this.props.actions.updateCommitHash(newCommitHash);
    this.triggerNewCommitHash(newCommitHash);
  };
  triggerNewCommitHash(commitHash) {
    const { libraryState } = this.props;
    const { title, packageManager, language, commitHashTab } = libraryState;
    const { component = {} } = libraryState;
    const params = {
      title,
      commitHash,
      packageManager,
      componentId: component.id,
      language,
      commitHashTab: commitHashTab || 'vulnerabilities',
    };
    browserHistory.push(
      `/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/libraries/${params.title}/${
        params.language
      }/${params.packageManager}/lid-${params.componentId}/commit_hash/${params.commitHash}`
    );
  }
  render() {
    const { libraryState } = this.props;
    const { commitHash, language, component } = libraryState;
    const { versions = [] } = component;
    const headerElements = [];
    let latestCommitHashes = [];
    let commitHashes = [];
    if (Helpers.isCommitHashSupportedByLanguage(language)) {
      latestCommitHashes = this.getLatestCommitHashes(versions, 'HEAD') || [];
      commitHashes = latestCommitHashes.map(commitHash => ({
        value: commitHash,
      }));
    }
    return (
      <div className="grid">
        <div className="grid__item col-1-1 pb+">
          <div className="grid grid--middle">
            <div className="grid__item col-1-2">
              <div className="grid grid--middle">
                <div className="grid__item col-1-4 font--h7">Commit Hash:</div>
                <div className="grid__item col-3-4">
                  <AutosuggestFilter
                    id={`commit-hash-filter`}
                    onChange={this.handleCommitHashChange}
                    options={commitHashes}
                    initialValue={(Helpers.isCommitHash(commitHash) && commitHash) || ''}
                    placeholder={'Select or enter a valid commit hash'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid__item col-1-1">{headerElements}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
    navigationState: state.navigationState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewCommitHash);
